<template>
  <v-page
    :page-id="portalId"
    :white="whiteBg"
    no-padding
    :dark-mode="props.color_mode === COLOR_MODES.DARK"
  >
    <transition name="fade" mode="out-in">
      <template v-if="isLoading">
        <div class="text-center p-5 mt-5">
          <v-loader />
        </div>
      </template>
      <template v-else-if="errorCode && errorCode === 404">
        <div class="text-center py-5 px-3 ">
          <toolbar transparent back fixed :logo="false" />
          <v-icon icon="help_outline" class="text-grey-70" size="3rem" />
          <h1 class="mb-1">404</h1>
          <p class="lead">This page doesn't exist</p>
          <v-button block primary class="mt-3" to="/">Take me home</v-button>
        </div>
      </template>
      <template v-else-if="template">
        <app-page
          :props="props"
          :template="template"
          :no-padding-bottom="!showBottomPadding(props)"
        />
      </template>
    </transition>
  </v-page>
</template>

<script>
import { isPresent } from "@/lib/utils"
import { showBottomPadding } from "@/lib/page-utils"
import { getCachedPage } from "@/lib/page-cache"
import fetchPageData from "@/lib/fetch-page-data"
import { COLOR_MODES } from "@/lib/stream-utils"

import AppPage from "@/components/AppPage"

export default {
  components: {
    AppPage,
    Toolbar: () => import("@/components/Toolbar")
  },

  data() {
    return {
      isLoading: false,
      template: null,
      props: {},
      errorCode: null,
      COLOR_MODES
    }
  },

  computed: {
    portalId() {
      return `dynamic-page-${this._uid}`
    },

    path() {
      return isPresent(this.forcePath) ? this.forcePath : this.$route.path
    },

    whiteBg() {
      return this.template === "WorkoutTemplate"
    }
  },

  methods: {
    showBottomPadding
  },

  mounted() {
    const path = this.forcePath || this.$route.path
    const pageCache = getCachedPage(path)

    if (isPresent(pageCache)) {
      this.template = pageCache.template
      this.props = pageCache.props
    } else {
      this.isLoading = true
    }

    fetchPageData(path)
      .then(data => {
        this.template = data.template
        this.props = data.props
      })
      .catch(err => {
        this.errorCode = err.response.status
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
</script>
